<template>
  <Popover
    trigger="click"
    class="FeedButton"
    :class="{ '-named': shown.labelRaw, '-current': feed }"
    :disabled="!feed"
    :bound-to="{ x: 'viewport' }"
    :margin="{ left: 4, right: 4 }"
    :offset="{ y: 6 }"
    popover-class="feed-menu-sheet popover-default"
    :trigger-attrs="{ title: name, 'aria-label': name, 'aria-haspopup': feed ? 'menu' : undefined }"
    @click="back"
  >
    <template #trigger>
      <span class="feed-button">
        <FAIcon
          v-if="shown.icon"
          class="fa-scale-110 fa-old-padding"
          :icon="shown.icon"
        />
        <span
          v-else
          class="feed-letter"
        >{{ shown.iconLetter }}</span>
        <span
          v-if="shown.labelRaw"
          class="feed-name"
        >{{ shown.labelRaw }}</span>
        <FAIcon
          v-if="feed"
          class="feed-caret"
          icon="chevron-down"
        />
      </span>
    </template>
    <template #content>
      <FeedMenu settings />
    </template>
  </Popover>
</template>

<script src="./feed_button.js"></script>

<style lang="scss">
.FeedButton {
  display: flex;
  min-width: 0;

  .popover-trigger-button {
    flex: 1 1 auto;
    min-width: 0;
    height: 100%;
    padding: 0 0.5em;
    box-sizing: border-box;
    color: inherit;
  }

  .feed-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.35em;
    min-width: 0;
  }

  .feed-letter {
    flex: none;
    font-weight: 700;
  }

  .feed-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .feed-caret {
    flex: none;
    font-size: 0.6em;
    opacity: 0.7;
  }
}

.feed-menu-sheet {
  width: min(22rem, calc(100vw - 8px));
  font-size: 1rem;

  /* the list scrolls, not the pop-up: its outline sticks out by 1px */
  .FeedMenu {
    max-height: calc(100vh - var(--navbar-height) - 1em);
    overflow-y: auto;
  }
}
</style>
